/* eslint-disable jsx-a11y/anchor-has-content */
/**
 * @file 文档搜索页列表的元素
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useCallback} from 'react';
import { getTextInfo } from './../../../../utils/getTextInfo';
import {ISearchItem} from '../../type';

interface IProps {
    key: string;
    item: ISearchItem;
    index: number;
    onClick?: (item: ISearchItem, index: number) => void;
}

const SearchdocItem: React.FC<IProps> = (props) => {
    const {
        item,
        index,
        onClick
    } = props;

    const handleOnClick = useCallback(() => {
        onClick && onClick(item, index);
    }, [item, index, onClick]);

    const propertiesObj = getTextInfo(item.title ?? '');

    return (
        <div className="paddle-searchall-item">
            <div className="paddle-searchall-item-title">
                <a href={item.path} onClick={handleOnClick} {...propertiesObj} />
            </div>
            <div className="paddle-searchall-item-path">
                <a href={item.path} title={item.title} onClick={handleOnClick}>
                    {item.path}
                </a>
            </div>
            <div
                className="paddle-searchall-item-content"
                dangerouslySetInnerHTML={{__html: item.content}}
            >
            </div>
        </div>
    );
};

export default SearchdocItem;
